import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IGradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/grade-unit';
import {
  IListTeacherGradingDTO,
  ListTeacherGradingDto,
} from '@app/infrastructure/models/list-teacher-grading-dto';
import { ITableColumns } from '@app/infrastructure/models/table';
import {
  ScoringRubric,
  SkillsRubric,
} from '@app/infrastructure/utils/constants';

@Component({
  selector: 'app-unit-grading-table-presentation',
  templateUrl: './unit-grading-list-presentation.component.html',
  styleUrls: ['./unit-grading-list-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitGradingListPresentationComponent {
  constructor(private router: Router) {}
  @Input() public dataSource: any[] = [];
  @Input() public gradingPeriod: any;
  @Input() public units: IGradeUnitListItemDTO[] = [];
  @Input() public displayedColumns: [] = [];
  @Input() public columnIdList = [];
  @Input() public skills = SkillsRubric;
  @Input() public scoringRubric = ScoringRubric;
  @Input() public skillsLength: string[] = [];
  @Input() public scoreGradingPeriod: boolean = true;

  public goToGradeView(id) {
    const unitNumber = id.split('-')[1];
    this.router.navigateByUrl(`${this.router.url}/${unitNumber}/unit-grading`);
  }

  public isSticky(column: ITableColumns): boolean {
    return column.columnId === 'name';
  }

  public getSkillScore(rubricSkill, rowCol): string {
    const scores: Array<any> = rowCol?.scores || [];
    const score = scores.find(
      (score) => score.rubricSkillId === rubricSkill.id,
    );

    return score?.score || 'N/A';
  }
}
